import { PropsWithChildren } from 'react'
import { useGetSponsoredListing } from '@/hooks/use-sponsored-listing'

const datesDescending = (a: any, b: any) => {
  const dateA = new Date(a.planned_start_date).getTime()
  const dateB = new Date(a.planned_start_date).getTime()

  if (dateA > dateB) return -1
  else if (dateB > dateA) return 1
  else return 0
}

interface Props extends PropsWithChildren {
  listingId: string
}

export const useSponsorshipData = ({ listingId }: Props) => {
  const { data: sponsoredListing, isLoading } = useGetSponsoredListing(listingId)
  const allSponsorships = Object.values(sponsoredListing?.sponsored_listings ?? {})
  const nonExpiredSponsorships = allSponsorships
    .filter((x: any) => x.state_machine !== 'history')
    .sort(datesDescending)

  const currentSponsorship =
    nonExpiredSponsorships.find((x: any) => x.state_machine === 'active') ??
    nonExpiredSponsorships[0]

  const hasBeenSponsored = Object.values(sponsoredListing?.sponsored_listings ?? {}).length > 0

  return { isLoading, hasBeenSponsored, currentSponsorship }
}
